<template>
  <b-navbar toggleable="lg">
    <b-navbar-brand href="/">
      <img id="logo" src="/logo.svg" alt="URBNRX">
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <span v-for="item in items" :key="item.label">
          <b-nav-item :href="item.to">{{ item.label }}</b-nav-item>
        </span>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>
<script>
export default {
  data() {
    return {
      items: [
        { to: '/', label: 'Home' },
        { to: '/services', label: 'Services' },
        { to: '/contact', label: 'Contact' },
      ],
    };
  },
};
</script>
